export default __webpack_public_path__ + "static/media/demo.b6848f88.mp4";